import axios from "axios";
import { getHeaders } from '../helpers';
import { getChestApiUrl } from "../../helpers";

const passengersEndpoint = `${getChestApiUrl()}/chestApi/passengers`

/**
 * Get all passengers from user.
 * 
 * @param {String} params.session Id of the user in the database
 */
const getPassengers = params => axios({
  method: 'get',
  url: passengersEndpoint,
  headers: getHeaders(),
  params
})

/**
 * Add new passenger to user.
 * 
 * @param {String} data.userId Id of the user in the database
 * @param {String} data.passenger Passenger data to add
 */
const addPassenger = data => axios({
  method: 'post',
  url: passengersEndpoint,
  headers: getHeaders(),
  data
})

/**
 * Update passenger from user.
 * 
 * @param {String} data.userId Id of the user in the database
 * @param {String} data.passenger Passenger data to add
 */
const updatePassenger = data => axios({
  method: 'put',
  url: passengersEndpoint,
  headers: getHeaders(),
  data
})

/**
 * Delete passenger from user.
 * 
 * @param {String} params.userId Id of the user in the database
 * @param {String} params.passengerId Id of the passenger to delete
 */
const deletePassenger = params => axios({
  method: 'delete',
  url: passengersEndpoint,
  headers: getHeaders(),
  params
})


export default {
  getPassengers,
  addPassenger,
  updatePassenger,
  deletePassenger
}